import { render, staticRenderFns } from "./OsCardSubTitle.vue?vue&type=template&id=c97817a8&scoped=true"
import script from "./OsCardSubTitle.vue?vue&type=script&lang=ts"
export * from "./OsCardSubTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97817a8",
  null
  
)

export default component.exports